import React from "react";

import { TagType, _Tag } from "./_Tag";

export function NewTag({
  type = "bold",
  testID = "new-tag",
  ...props
}: TagType) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-purple-strong"
        color="text-accent-purple-weak"
        testID={testID}
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-purple-weak"
      color="text-accent-purple-strong"
      testID={testID}
      {...props}
    />
  );
}
